import styled from "styled-components";

export const AttachmentInputButtonDiv = styled.div`
    display: inline-flex;
    border-radius: 5px;
    margin-bottom: 10px;
    box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.2);
`;

export const AttachmentCloseClickDiv = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
`;
